(function($){
  'use strict';

  var modal = {
    dom: function() {
      this.$activeModal;
      this.$modalToggle = $('[data-toggle="modal"]');
      this.$modal       = $('[data-js-hook="modal"]');
      this.$close       = $('[data-dismiss="modal"]');
      this.$select      = $('[data-modal-current]');
      this.$ajaxModalTrigger = $('[data-toggle="ajax-modal');
    },

    hideModal: function() {
      if (modal.$activeModal) {
        modal.$activeModal.removeClass('show').fadeOut(function() {
          $('body').removeClass('modal-open');
        });
        modal.$activeModal = null;
        setTimeout(function() {
          if ($('[data-modal-id]')) {
            $('[data-modal-id]').hide();
            $('[data-modal-id="1"]').show();
            if (typeof $smallModals != 'undefined' && $smallModals.length) {
              $.each($smallModals, function() {
                $(this).find('.modal__container').addClass('modal__container--no-width');
              });
            }
          }
        }, 500);
      }
    },

    showModal: function($target) {
      modal.$activeModal = $target;
      $('body').addClass('modal-open');
      modal.$activeModal.fadeIn(function() {
        $(this).addClass('show');
      });
    },

    showHideModal: function() {
      this.$modalToggle.click(function(e) {
        if (!e.ctrlKey && !e.metaKey) {
          e.preventDefault();
          var target = $(this).data('target');
          var embed = $(target).find('.modal__iframe-wrap');
          if ($(target).length) {
            if ($(target).is(':visible')) {
              modal.hideModal($(target));
            }
            else {
              if (embed.length) {
                embed.each(function() {
                  var $this = $(this);
                  if (!$this.children('iframe').length) {
                    $this.append(decodeURIComponent($this.data('embed-code')));
                    setTimeout(function() {
                      $('.modal__loading', $this).fadeOut();
                    }, 2000);
                  }
                });
              }
              else {
                $('.modal__loading', $(target)).fadeOut();
              }

              modal.hideModal();

              // target specific page in modal
              var page = $(this).data('modal-page');
              if (typeof page != 'undefined' && $('.modal__page[data-modal-id="' + page + '"]', target).length) {
                $('.modal__page', target).hide();
                $('.modal__page[data-modal-id="' + page + '"]', target).show();
                $(target).find('.modal__container--no-width').removeClass('modal__container--no-width');
              }

              modal.showModal($(target));
            }
          }
        }
      });
    },

    closeModal: function() {
      this.$close.click(function(event) {
        event.preventDefault();
        modal.hideModal();
      });

      $(document).keyup(function(event) {
        if (event.key === "Escape" && typeof modal.$activeModal != 'undefined') {
          modal.hideModal();
        }
      });
    },

    autoModal: function() {
      if (window.location.search != 'undefined') {
        var urlParams = window.location.search.replace('?','');
        var aUrlParams = urlParams.split('&');
        var target = false;

        $.each(aUrlParams, function(key, value) {
          var aParamSplit = value.split('=');
          if (aParamSplit[0] == 'modal') {
            target = aParamSplit[1];
          }
        });

        if (target) {
          modal.showModal($('#' + target));
        }
      }
    },

    ajaxModal: function() {
      this.$ajaxModalTrigger.click(function(e) {
        e.preventDefault();

        var data = [];
        var name = $(this).data('toggle');
        var url = $(this).data('target');
        var $modal = $('#' + name);
        var $content = $modal.find('.modal-content');
        var $loader = $modal.find('.modal__loader');
        var $modalClose = $modal.find('[data-dismiss="modal"]');

        modal.showModal($modal);

        var sParams = url.substring(url.indexOf('?') + 1);
        var aParamsTemp = sParams.split('&');
        aParamsTemp.forEach(function(value) {
          var aParam = value.split('=');
          var param = aParam[0];
          value = aParam[1];
          data[param] = value;
        });

        $content.load(
          url,
          { data: data },
          function(response, status) {
            if (status !== 'error') {
              $loader.fadeOut(function() {
                $content.fadeIn();
              });
            }
          }
        );

        $modalClose.click(function() {
          $content.fadeOut(function() {
            $content.html('');
            $loader.show();
          });
        });

      });
    },

    ready: function() {
      this.dom();
      this.showHideModal();
      this.closeModal();
      this.autoModal();
      this.ajaxModal();
    }
  };

  $(function() { modal.ready(); });

})(jQuery);
